exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.error-code-container[data-v-e4e0f6f2] {\n  text-align: center;\n  font-size: 0.6em;\n}\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/share/KpaymentMessages.vue"],"names":[],"mappings":";AA6FA;EACE,mBAAkB;EAClB,iBAAgB;CACjB","file":"KpaymentMessages.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.error-code-container {\n  text-align: center;\n  font-size: 0.6em;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e4e0f6f2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/share/KpaymentMessages.vue
// module id = E5E0
// module chunks = 8